// Utilities
import { defineStore } from 'pinia'

export const useCommunicationStore = defineStore('communication', {
  state: () => ({
    snack: {
      show: false,
      message: null,
      color: null,
      vertical: false,
      showCloseAction: true,
      timeout: 4000
    },
    routeSnack: {
      show: false,
      color: null,
      message: null,
      route: null,
      timeout: 4000
    }
  }),
  actions: {
    setSnack(snack) {
      // Reset timeout to default if not specified
      if (!snack.timeout) snack.timeout = 4000
      Object.assign(this.snack, snack)
    },
    setRouteSnack(snack) {
      // Reset timeout to default if not specified
      if (!snack.timeout) snack.timeout = 4000
      Object.assign(this.routeSnack, snack)
    }
  }
})
